import * as React from "react"
import * as Immutable from 'immutable'

import { SprocketAsset, SaleAdvert, VerifiedAspect } from "../../types/types";
import CrumbTrail from "../shared/advert/CrumbTrail";
import { ContentMapType } from "../shared/advert/ContentMap";
import { AdvertiserInfo } from "../shared/advert/AdvertiserInfo";
import Surroundings from "./components/Surroundings";
import Skiing from "../shared/advert/Skiing";
import Youtube from "../shared/advert/Youtube";
import Maintenance from "./components/Maintenance";
import BuildingState from "./components/BuildingState";
import ObjectDivision from "./components/ObjectDivision";
import TerrainBuildings from "./components/TerrainBuildings";
import Remarks from "./components/Remarks";
import Description from "./components/Description";
import { Action, AsyncState, unloadedAsyncState } from "widgets-for-react";

type Props = {
  advert: SaleAdvert
  placeholderImage: SprocketAsset
  onTooltipToggle: () => void
  onCloseTooltip: () => void
  tooltipOpen: boolean
  mapType: ContentMapType
  setMapType: (t: ContentMapType) => void
  mapsIcon: SprocketAsset
  googleMapsKey: string
  locale: string
  verifiedAspects: AsyncState<VerifiedAspect[]>
  setVerifiedAspects: (output: Action<AsyncState<VerifiedAspect[]>>) => void

}

export default (props: Props) : JSX.Element => {
  const translation = !!props.advert.translations ?
    Immutable.List(props.advert.translations.nodes).filter(x => x.locale == props.locale).first() :
    null
  return <>
    <CrumbTrail
      advert={props.advert}
      objectName={!!translation ? translation.objectName : null}
    />
    <hr/>

    <AdvertiserInfo
      user={props.advert.user}
      full_name={props.advert.advertiserFullName}
      user_placeholder={props.placeholderImage}
      tooltip_open={props.tooltipOpen}
      onTooltipToggle={() => props.onTooltipToggle()}
      onCloseTooltip={() => props.onCloseTooltip()}
      contact_person={props.advert.contactPerson}
      overviewPath={props.advert.user.salesOverviewPath}
      verifiedAspects={props.verifiedAspects}
      setVerifiedAspects={props.setVerifiedAspects}
    />

    <Description
      advert={props.advert}
      translation={translation}
    />

    <Surroundings
      advert={props.advert}
      mapType={props.mapType}
      setMapType={(m) => props.setMapType(m)}
      mapsIcon={props.mapsIcon}
      googleMapsKey={props.googleMapsKey}
      translation={translation}
    />

    <Skiing
      advert={props.advert}
      translation={translation}
    />

  <Maintenance
      advert={props.advert}
    />

    <BuildingState
      advert={props.advert}
      translation={translation}
    />

    <ObjectDivision
      advert={props.advert}
      translation={translation}
    />

    <TerrainBuildings
      advert={props.advert}
      translation={translation}
    />

    <Remarks
      advert={props.advert}
      translation={translation}
    />

    <Youtube
      advert={props.advert}
    />
  </>
}
